import clsx from 'clsx';
import { Link, useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';
import type { Menu } from 'lib/burokshop/types';

export function FooterMenuItem({ item }: { item: Menu }) {
  const location = useLocation();
  const [active, setActive] = useState(location.pathname === item.path);

  useEffect(() => {
    setActive(location.pathname === item.path);
  }, [location.pathname, item.path]);

  return (
    <li>
      <Link
        to={item.path}
        className={clsx(
          'block p-2 text-lg underline-offset-4 hover:text-black hover:underline md:inline-block md:text-sm dark:hover:text-neutral-300',
          {
            'text-black dark:text-neutral-300': active
          }
        )}
      >
        {item.title}
      </Link>
    </li>
  );
}

export default function FooterMenu({ menu }: { menu: Menu[] }) {
  if (!menu.length) return null;

  return (
    <nav>
      <ul>
        {menu.map((item: Menu) => {
          return <FooterMenuItem key={item.title} item={item} />;
        })}
      </ul>
    </nav>
  );
}



